export const environment = {
  production: false,
  previewMode: false, //Set to true for draft content
  contentful: {
    spaceId: 'f8ocmwerjdqe',
    environmentId: 'master',
    accessToken: 'h1ch3hwgChxufGrpCOWSSt1r8nka9aB1ow2PZ1_tBNU', // Content Delivery API - access token
    graphqlEndpoint:
      'https://graphql.contentful.com/content/v1/spaces/f8ocmwerjdqe/environments/master',

    managementAccessToken: 'CFPAT-9hLk9hVOAI5FQmtpB6vYMrRDLAHgNl37u5WJQABeOiI', // CMA Tokens

    previewAccessToken: 'MZXdAF_zOZlEYIlt7_valn50fkyryKY143Z2PPy-Zfk', // Content Preview API - access token
    previewGraphqlEndpoint:
      'https://graphql.contentful.com/content/v1/spaces/f8ocmwerjdqe/environments/master',
  },
};
